import { PhoneField, validatePhoneNumber } from '@boltenergy-be/design-system'
import { Controller, useFormContext } from 'react-hook-form'
import { PhoneProps } from 'components/inputs/phone/types'
import { useTranslation } from 'next-i18next/pages'
import { getFieldName } from 'components/inputs/utils'

const Phone = ({ required = true, invalidErrorText, parentDotPath, identifier = 'mobilePhone', label, ...props }: PhoneProps) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  // Constants
  const fieldKey = getFieldName(identifier, parentDotPath)

  // React Hook Form
  const { control } = useFormContext()

  return (
    <Controller
      {...{ control }}
      name={fieldKey}
      rules={{
        required: required ? t(($) => $.required, { ns: 'validation' }) : false,
        validate: (value: string) => {
          if (!required && !value) return true
          return validatePhoneNumber(value || '').valid || invalidErrorText || t(($) => $.phone.errors.invalid)
        }
      }}
      render={({ field, fieldState }) => (
        <PhoneField
          {...props}
          ref={field.ref}
          name={field.name}
          value={field.value}
          label={label || t(($) => $.phone.label)}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={fieldState?.error?.message}
          {...(!required && { optionalText: t(($) => $.optional, { ns: 'common' }) })}
        />
      )}
    />
  )
}

export default Phone
